import axiosClient from "src/features/axios/client";
import { SupportFormData } from "../components/SupportPage";

class SupportService {
  async createSupportTicket(data: SupportFormData) {
    return await axiosClient
      .post("/api/support/", data)
      .then((res) => res.data);
  }
}

const supportService = new SupportService();

export default supportService;
